import { render } from "./UpgradabilityPath.vue?vue&type=template&id=6f9f1a97&scoped=true"
import script from "./UpgradabilityPath.vue?vue&type=script&lang=js"
export * from "./UpgradabilityPath.vue?vue&type=script&lang=js"

import "./UpgradabilityPath.vue?vue&type=style&index=0&id=6f9f1a97&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9f1a97"]])

export default __exports__